import Button from '@cobliteam/ui/components/Button';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';
import { cn } from '@cobliteam/ui/utils';

interface NoDriverFoundProps {
  creatable: boolean;
  onCreateDriverClick: () => void;
}

const NoDriverFound = ({ creatable, onCreateDriverClick }: NoDriverFoundProps) => {
  return (
    <div className={cn('flex flex-col items-center justify-center px-auto')}>
      <span className='circle mb-2.5 rounded-full bg-gray-3 p-2'>
        <Icon name='square-user-round' size='md' color='secondary' />
      </span>
      <Typography variant='body' color='secondary'>
        Não existe motorista cadastrado com esse nome.
      </Typography>
      {creatable && (
        <Button variant='outlined' size='sm' className='mt-2.5' onClick={onCreateDriverClick}>
          Adicionar motorista
        </Button>
      )}
    </div>
  );
};

export default NoDriverFound;
